import React from "react";
import style from "./CoreTeam.module.css";
import profile from "./Card/data";
import Card from "./Card/Card";
export default function CoreTeam() {
  return (
    <div className={style.mainContainer}>
      <div className={style.innerContainer}>
        <div className={style.detailDiv}>
          <h1 className={style.heading}>
            Our <strong> Core </strong> Team
          </h1>
          <p className={style.description}>
            Every member of our team owns the company as their own.<br></br>{" "}
            Together we ensure incredible delivery in the field of outsourcing
            software development.
          </p>
        </div>

        <div className={style.cardsDiv}>
          {profile.map((data, index) => (
            <Card
              key={index}
              name={data.name}
              designation={data.designation}
              imgSrc={data.imgSrc}
              skype={data.skypeLink}
              linkedIn={data.linkedInLink}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
